import React, { Fragment, useMemo, useState } from 'react';
import { Button, Col, Collapse, DatePicker, Row, Select } from 'antd';
import { FaRegCalendarAlt } from "react-icons/fa";
import { FaJournalWhills } from "react-icons/fa";

import '../css/collasible.css';
import ReportsToPDF from '../components/ReportsToPDF';
import { BlobProvider } from '@react-pdf/renderer';
import { useLoaderData, useParams } from 'react-router-dom';
import GHSymbol from '../components/GHSymbol';
import formatAmount from '../../utils/formatAmount';


const options = [
  {
    value: 'jack',
    label: 'Jack',
  },
  {
    value: 'lucy',
    label: 'Lucy',
  },
  {
    value: 'Yiminghe',
    label: 'yiminghe',
  },
];

const data = [
  { name: 'ASSETS', 
  balance: 0, 
  subAccounts: [
    { subAccounts: [
      {key: 1, label: 'Current Assets', balance: 20, children: [
        {label: 'Stock Valuation', balance: 80}
      ],}
    ]},
    { subAccounts: [
      {key: 2, label: 'Receivables', balance: 70, children: [
        { label: 'Account Receivable', balance: 70}
      ]}
    ]},
    { name: 'Prepayments', balance: 90},
    { name: 'Bank and Cash', balance: 90}
  ]},
  { name: 'LIABILITY', balance: 0, subAccounts: [
    { subAccounts: [
      {key: 1, label: 'Current Liability', balance: 30, children: [
        {label: 'Production', balance: 30}
      ],}
    ]},
    { subAccounts: [
      {key: 2, label: 'Payables', balance: 50, children: [
        {label: 'Account Payable', balance: 50}
      ]}
    ]}
  ]},
  { name: 'EQUITY', balance: 0, subAccounts: [
    { name: 'Current Year Earnings', balance: 90},
    { name: 'Retained Earnings', balance: 90}
  ]}
]



const FinancialReports = () => {
  const [filter, setFilter] = useState({date: '', journal_code: ''})
  const report = useLoaderData();
  const params = useParams();

  const onChangeDate = (date, dateString) => setFilter({ ...filter, date: dateString });
  const onChangeJournal = (v) => setFilter({ ...filter, journal_code: v });
  

  const memoizedDocument = useMemo(() => <ReportsToPDF data={report} reportType={params.id} />, []);


  return (
    <div className='container mx-auto h-full' style={{maxWidth: '900px'}}>
      <div className='bg-white mb-3 p-1'>
        <div>
          <h2 className='font-semibold text-xl text-[#04949b]'>{params.id.replace(/-/g, ' ').toUpperCase()}</h2>
        </div>
        <div className='flex justify-between p-2'>
          <div>
            <Button className='bg-[#04949b] text-white border-0 hover:bg-[#04949b] font-semibold'>
              <BlobProvider document={memoizedDocument}>
                  {({ url, loading, error }) => {
                    if (loading) return 'Loading document...';
                    if (error) return 'Error loading document';
                    return (
                      <a href={url} target="_blank" rel="noopener noreferrer">
                        PDF
                      </a>
                    );
                  }}
                </BlobProvider>
            </Button>
          </div>
          <Row className='w-1/2'>
            <Col lg={10} className='flex items-center text-[#04949b] w-1/2'>
              <span className='w-1/2 font-normal flex items-center font-semibold'><FaRegCalendarAlt className='me-1'/>As of</span>
              <DatePicker suffixIcon={false} defaultValue={filter.date} onChange={onChangeDate} className='border-x-0 border-t-0 ps-0 text-[#04949b] font-semibold focus:shadow-none input-outline-none w-full border-0 font-normal'/>
            </Col>
            <Col lg={10} className='flex items-center text-[#04949b] w-1/2'>
              <span className='w-1/2 font-normal flex items-center font-semibold'><FaJournalWhills className='me-1'/>Journals:</span>
              <Select variant="borderless" value={filter.journal_code} onChange={onChangeJournal} suffixIcon={false} className='w-full font-semibold text-[#04949b]' options={options}/>
            </Col>
          </Row>
        </div>
      </div>
      <div className='bg-white p-3'>
        {report.map((report, idx) =>
          <div key={idx} className='mb-2'>
            <div className='flex justify-between border-b-2 border-black'>
              <h4 className='font-medium'>{report.name}</h4>
              <h4 className='font-medium'><GHSymbol /> {formatAmount(report.sub.reduce((prevBalance, currentBalance) => (currentBalance.account.reduce((prev, current) => (current.amount + prev), 0) + prevBalance ),0))}</h4>
            </div>
              {/* {report.sub.map((subAccount, id) =>  */}
                <div className='ms-4'>
                  {/* {subAccount.subAccounts ?  */}
                    <Collapse defaultActiveKey={['1']} ghost className='m-0 p-0' 
                      items={report.sub.map((subAccount, ids) => {
                        return (
                          {
                            key: subAccount.id,
                            label: 
                              <div key={subAccount.id} className='flex justify-between font-medium'>
                                <p className='m-0 p-0 '>{subAccount.name}</p>
                                <p className='m-0 p-0' style={{fontSize: '13.5px'}}><GHSymbol /> {formatAmount(subAccount.account.reduce((prev, current) => (current.amount + prev), 0))}</p>
                              </div>,
                            children: subAccount.account.map(children=> {
                              return(
                                <div key={children.id} className='flex justify-between'>
                                  <p className='m-0 p-0'>{children.name}</p>
                                  <p className='m-0 p-0' style={{fontSize: '13px'}}><GHSymbol /> {formatAmount(children.amount)}</p>
                                </div>
                              )
                            })
                          }
                        )
                      })}
                    />
                    {/* // <div className='flex justify-between border-b-2'>
                    //   <h6 >{subAccount.name}</h6>
                    //   <h6 >{subAccount.balance}</h6>
                    // </div> */}
                  {/* } */}
                </div>
              {/* )} */}
          </div>
        )}
        {/* <div className='mb-2'>
          <h4 className='border-b-2 border-black'>LIABILITY</h4>
          <div className='ms-4'>
            <h5 className='border-b-2'>Current Liabilities</h5>
            <div className='ms-4'>
              <Collapse defaultActiveKey={['1']} ghost items={liabilityItems} className='m-0 p-0'/>
            </div>
          </div>
        </div> */}
        {/* <div className='mb-2'>
          <h4 className='border-b-2 border-black'>EQUITY</h4>
          <div className='ms-4'>
            <h5 className='border-b-2'>Unallocated Earnings</h5>
            <div className='ms-4'>
              <h6 className='border-b-2'>Current Year Unallocated Earnings</h6>
              <div className='ms-4'>
                <p className='m-0 border-b-2 text-[#04949b]'>Current Year Earnings</p>
                <p className='m-0 border-b-2'>Current Year Allocated Earnings</p>
              </div>
              <h6 className='border-b-2'>Previous Years Unallocated Earnings</h6>
            </div>
            <h5>Retained Earnings</h5>
          </div>
        </div> */}
      </div>
    </div>
  )
};

export default FinancialReports;